module.exports = __webpack_public_path__ + "img/selected4-min.9d31d1d4.png";